import React from 'react'
import BasicLayoutContainer from './BasicLayoutContainer'

const BasicLayout = (props) => <BasicLayoutContainer {...props} />
export default BasicLayout
